import { $http } from '@/services/http-common'

export default {
  loginUser (payload) {
    return $http.post('/login', payload)
  },
  logoutUser () {
    return $http.post('/logout')
  },
  signUpUser (payload) {
    return $http.post('/signup', payload)
  }
}
